import React from 'react';
import PromotionList from 'components/Content/PromotionList/PromotionList';
import { wrapFunctionalComponent } from 'utils/framework';

const PromotionListExclusiveOffersHandler = ({ showFallback, user, ...restProps }) => {
    return <PromotionList {...restProps} />;
};

export default wrapFunctionalComponent(PromotionListExclusiveOffersHandler, 'PromotionListExclusiveOffersHandler');
